<avd-styling-card-shell [label]="label" [inverseMode]="inverseMode">
    <div token-card-preview class="preview">
        <div
            class="preview__inner"
            [class.preview__inner--inverse]="inverseMode"
            [style.border-color]="borderColor"
        ></div>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
